<template>
   <div class="row"> 
    
       <div class="col-md-12">
        <button type="button" v-if="expandedView" :disabled="!this.expandedRowDetail.listControl "  class="btn btn-light border btn-sm mb-3 py-1 float-start" @click="toggleExpand">
            <small> {{  this.expandedRowDetail.autoExpandAll == true ?  $t('collapse_all') : $t('expand_all')}}</small>
        </button>
        <button type="button" class="btn btn-light-danger btn-icon  w-30px h-30px mb-3 float-end" @click="deleteState()">
            <i class="bi bi-arrow-clockwise"></i>
       </button>
        <button type="button" class="btn btn-secondary btn-icon  w-30px h-30px mb-3 me-3 float-end" @click="saveState()">
            <i class="bi bi-aspect-ratio"></i>
       </button>
       </div>
    </div>
</template>
<script> 
import axios from 'axios';
export default {
    name: "ListOptions",
    props: {
        name: Object,
        state: Object,
        expandedView: {
            type : Boolean,
            default : false
        },
        expandedRowDetail:{
            type : Object,
            default: () => ({
            autoExpandAll: false,
            listControl: false,
          }),
        },

    },
    data() {
        return {
            isViewListOptionsModal: false,
            storageKey: 'dx_' + this.name,
        };
    },
    methods: {
        getState(){
            const params = {
                session_id: this.$getUser().session_id,
                user_id: this.$getUser().id,
                table_code: this.name
            };
            axios.post("/api/Users/GetGridSession", params, {'Content-Type': 'application/json'}).then(() => {
              
            })
            .catch((error) => {
                console.error(error);
            }); 
        },
        saveState(){
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_save_this_state'),
                confirmButtonColor: "#50cd89",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('save'),
                icon: 'info'
            })
            .then((result) => {
                if (result.isConfirmed) {
                    const state = this.$parent.$refs.dataGrid.instance.state();
                    sessionStorage.setItem(this.storageKey, JSON.stringify(state));
                    if(state !== null && state !== ''){
                        const params = {
                            session_id: this.$getUser().session_id,
                            user_id: this.$getUser().id,
                            state_detail: JSON.stringify(state),
                            table_code: this.name,
                        };
                        axios.post("/api/Users/SetGridSession", params, {'Content-Type': 'application/json'}).then(() => {
                            this.$swal(this.$t('success'), this.$t('state_saved_succesfully'), 'success');  
                        })
                        .catch((error) => {
                            console.error(error);
                        });  
                    }   
                }
            }); 
        },
        deleteState(){
            const dataGridInstance = this.$parent.$refs.dataGrid.instance;
            const params = {
                session_id: this.$getUser().session_id,
                user_id: this.$getUser().id,
                table_code: this.name
            };
            this.$swal.fire({
                title: this.$t('are_you_sure_you_want_to_restore_to_factory_settings'),
                confirmButtonColor: "#f1416c",
                showDenyButton: false,
                showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
                confirmButtonText: this.$t('confirm'),
                icon: 'info'
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post("/api/Users/DeleteGridSession", params, { 'Content-Type': 'application/json' }).then(() => {
                        sessionStorage.removeItem('dx_' + this.name);
                        dataGridInstance.clearGrouping();
                        dataGridInstance.clearFilter();
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                }
            })
        },
        toggleExpand() {
            this.$emit('toggle-expand');
        }
    }
}; 
</script>